"use strict";
require('es6-promise');
require('es6-shim');
require('ie-shim');
require('reflect-metadata');
require('./zone-browser');
//# sourceMappingURL=browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-universal-polyfills/browser.js
// module id = 342
// module chunks = 0